export default {
    name: 'MetadataTab',
    props: {
        recallData: {
            type: Object,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        tokenPercentage() {
            if (!this.recallData?.metadata?.llm) {
                return { input: 0, output: 0 }
            }
            const total = this.recallData.metadata.llm.total_tokens
            const input = this.recallData.metadata.llm.input_tokens
            const output = this.recallData.metadata.llm.output_tokens

            return {
                input: (input / total) * 100,
                output: (output / total) * 100
            }
        },
        publishedDate() {
            if (!this.recallData?.changelog || !Array.isArray(this.recallData.changelog)) {
                return null
            }
            const publishEntry = this.recallData.changelog.find(entry => entry.action === 'publish')
            return publishEntry ? publishEntry.timestamp : null
        }
    },
    methods: {
        formatDateTime(date) {
            if (!date) return '-'
            try {
                const dateValue = date?.$date || date
                const d = new Date(dateValue)
                if (isNaN(d.getTime())) return '-'
                // Format as absolute UTC date/time
                const pad = n => n.toString().padStart(2, '0')
                let hours = d.getUTCHours()
                const minutes = pad(d.getUTCMinutes())
                const seconds = pad(d.getUTCSeconds())
                const ampm = hours >= 12 ? 'PM' : 'AM'
                hours = hours % 12
                hours = hours ? hours : 12 // the hour '0' should be '12'
                return `${pad(d.getUTCMonth() + 1)}/${pad(d.getUTCDate())}/${d.getUTCFullYear()} ${pad(hours)}:${minutes}:${seconds} ${ampm}`
            } catch (error) {
                return '-'
            }
        },

        formatNumber(num) {
            if (num === null || num === undefined) return '-'
            return num.toLocaleString('en-US')
        },

        getStatusClass(status) {
            const statusMap = {
                'COMPLETED': 'badge-success',
                'PENDING': 'badge-warning',
                'IN_PROGRESS': 'badge-info',
                'FAILED': 'badge-danger'
            }
            return statusMap[status] || 'badge-secondary'
        }
    }
}
